import IconButton from '@inbox-demo-nx/ui-icon-button';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { Text, useSx, View } from 'dripsy';
import { useEffect } from 'react';

import NewChatIcon from './ic-new-chat.svg';
import ArrowLeftIcon from './icon-arrow-left.svg';

export default function useInboxNavigationHeader() {
  const navigation = useNavigation<NativeStackNavigationProp<any>>();

  const sx = useSx();

  useEffect(() => {
    navigation.setOptions({
      header(props) {
        return (
          <View
            sx={{
              position: 'relative',
              height: 44,
              backgroundColor: 'background',
              borderBottomWidth: 1,
              borderBottomColor: '#D9D9D9',
              alignItems: 'center',
              justifyContent: 'center',
              pb: 4,
            }}
          >
            <IconButton
              style={sx({ position: 'absolute', left: 10 })}
              onPress={() => props.navigation.goBack()}
            >
              <ArrowLeftIcon />
            </IconButton>
            <NewChatIcon style={{ position: 'absolute', right: 10 }} />
            <Text
              sx={{
                fontWeight: '700',
                variant: 'styles.textMedium',
                textAlign: 'center',
              }}
            >
              Inbox
            </Text>
          </View>
        );
      },
    });
  }, [navigation, sx]);
}
